import { defaultTransitionClass, themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const selectInputWrapperClass = style({
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
});

export const customCaretClass = style([
  defaultTransitionClass,
  {
    position: 'absolute',
    right: 10,
    top: 12,
    fontSize: themeVars.font.size.iconLg,
    cursor: 'pointer',
  },
]);
